import getPrizeOffset from './getPrizeOffset';

export default getPrizeOffset;
